import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-relation-manager',
  templateUrl: './dashboard-relation-manager.component.html',
  styleUrls: ['./dashboard-relation-manager.component.scss']
})
export class RelationManagerDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
